import React, { Component, useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import "./NavMenu.css";
import { useTranslation } from "react-i18next";
import Logo from "../components/images/Home_Icon.png";

export const NavMenu = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };
  const { t, i18n } = useTranslation();
  const USFAQ =
    "https://" + window.location.hostname + "/rr/downloads/USFAQs.pdf";
  const intFAQ =
    "https://" +
    window.location.hostname +
    "/rr/downloads/InternationalFAQs.pdf";
  const Disclosure =
    "https://" +
    window.location.hostname +
    "/rr/downloads/Disburse-Phys_MC_Disclosure_SF_Standard.pdf";
  return (
    <header>
      <Navbar
        className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3"
        container
        light
        name="navigation"
      >
        <NavbarBrand tag={Link} to="/" state={{ data: true }}>
          <img src={Logo} alt="Home" width={150} />
        </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
        <Collapse
          className="d-sm-inline-flex flex-sm-row-reverse"
          isOpen={collapsed}
          navbar
        >
          <ul className="navbar-nav flex-grow">
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret className="nav-link lead">
                {t("layout.pressRelease")}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem
                  href={t("layout.cpscLink")}
                  target="_blank"
                  rel="noopener"
                  className="nav-link lead"
                >
                  {t("layout.cpsc")}
                </DropdownItem>
                <DropdownItem
                  href={t("layout.healthCanadaLink")}
                  target="_blank"
                  rel="noopener"
                  className="nav-link lead"
                >
                  {t("layout.healthCanada")}
                </DropdownItem>
                <DropdownItem
                  href={t("layout.australiaLink")}
                  target="_blank"
                  rel="noopener"
                  className="nav-link lead"
                >
                  {t("layout.australia")}
                </DropdownItem>
                {/* <DropdownItem divider />
                <DropdownItem>Reset</DropdownItem> */}
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret className="nav-link lead">
                {t("layout.faqs")}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem
                  href={USFAQ}
                  target="_blank"
                  rel="noopener"
                  className="nav-link lead"
                >
                  {t("layout.usFaqs")}
                </DropdownItem>
                <DropdownItem
                  href={intFAQ}
                  target="_blank"
                  rel="noopener"
                  className="nav-link lead"
                >
                  {t("layout.otherFaqs")}
                </DropdownItem>
                {/* <DropdownItem divider />
                <DropdownItem>Reset</DropdownItem> */}
              </DropdownMenu>
            </UncontrolledDropdown>
            {/* <NavItem></NavItem> */}
            {/* <NavItem></NavItem> */}
            <NavItem>
              <a href={Disclosure} className="nav-link lead" target="_blank">
                {t("layout.disclosure")}
              </a>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret className="nav-link lead">
                {t("layout.privacy")}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem
                  href={t("layout.privacyLink")}
                  target="_blank"
                  rel="noopener"
                  className="nav-link lead"
                >
                  {t("layout.privacyUs")}
                </DropdownItem>
                <DropdownItem
                  href={t("layout.privacyLinkUk")}
                  target="_blank"
                  rel="noopener"
                  className="nav-link lead"
                >
                  {t("layout.privacyUk")}
                </DropdownItem>
                {/* <DropdownItem divider />
                <DropdownItem>Reset</DropdownItem> */}
              </DropdownMenu>
            </UncontrolledDropdown>
            <NavItem>
              <NavLink tag={Link} className="nav-link lead" to="/ContactUs">
                {t("layout.contactUs")}
              </NavLink>
            </NavItem>
          </ul>
        </Collapse>
      </Navbar>
    </header>
  );
};
